import { useState } from 'react'
import { Edit, useTranslate } from 'react-admin'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import PackageForm from './PackageForm'

const PackageEdit = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)

    return (
        <>
            <BackFromEditorButton isPristineForm={isPristineForm} backToRouteURL="/package" />
            <Edit title={translate('manager.resources.package.edit')} {...props}>
                <PackageForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                    isEdit={true}
                />
            </Edit>
        </>
    )
}

export default PackageEdit
